// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__hksjb","title":"Info_title__1gkYA","selects":"Info_selects__1Hk_L","requiredAsterisk":"Info_requiredAsterisk__1_j1b"};